//Created by wangshuyi on 2020-05-11.

'use strict';

import VueCookies from 'vue-cookies';
import moment from 'moment';
import i18n from "@/i18n";

const actions = {
  async login({ commit }, loginInfo) {
    const $vue = this._vm;
    const data = [
      {
        USER_CODE: loginInfo.username,
        PASSWORD: loginInfo.password,
        SYS_TYPE: 20011003,
        USER_ID: '',
        LOGIN_WAY: 0,
        LOGIN_TYPE: 0,
        MAC: '',
        HOST: '',
        IP: '',
        INTERNET_IP: '',
        INTERNET_IP_AREA: ''
      }
    ];
    await $vue.$h5Api({
      type: `2001`,
      data,
      showMessage: false
    }).then(({ data }) => {
      /*let flag = false;
      data.SYSLIST.forEach(item =>{
        if(item.SYS_CODE === 20011003 && data.LIST?.[0]?.OPER_STATUS !== 20031003){
          flag = true;
        }
      })*/
      commit('afterLogin', data);
    }).catch(e => {
      throw e;
    });
  },
  async autoLoginById({ commit }, userId){
    const $vue = this._vm;
    const data = [
      {
        USER_CODE: '',
        PASSWORD: '',
        SYS_TYPE: 20011003,
        USER_ID: userId,
        LOGIN_WAY: 1,
        LOGIN_TYPE: 0,
        MAC: '',
        HOST: '',
        IP: '',
        INTERNET_IP: '',
        INTERNET_IP_AREA: ''
      }
    ];
    await $vue.$h5Api({
      type: `2001`,
      data,
    }).then(({ data }) => {
      commit('afterLogin', data);
    }).catch(e => {
      console.error(e);
      throw false;
    });
  },

  refresh({ commit }) {
    let $vue = this._vm;

    return $vue.$ajax({
      url: '/system/auth/user/refresh'
    }).then(({ data }) => {
      commit('saveUserInfo', data);
      commit('saveToken', data._id);

      return data;
    });
  },

  autoLoginByCookie({ commit, state }) {
    let $vue = this._vm;
    let cookieToken = VueCookies.get(state.cookieName);

    if (cookieToken) {
      return $vue.$ajax({
        url: '/login/autoLogin/{token}',
        pathData: { token: cookieToken },
      }).then(({ data }) => {
        commit('saveUserInfo', data);
        commit('saveToken', data._id);

        return data;
      });
    } else {
      throw false;
    }
  },


  logout({ commit }) {
    commit('clearUserInfoAndToken');

    return Promise.resolve();
  },

  checkLang({state, dispatch, commit}) {
    if (state.checkLang) {
      return Promise.resolve();
    }

    const $vue = this._vm;
    state.checkLang = true;
    const localLastTime = localStorage.getItem('langTime');
    if (localLastTime) {
      return $vue.$h5Api({
        type: '2019',
        data: [{}],
      }).then(({data}) => {
        if (moment(localLastTime).isBefore(moment(data.value))) {
          return dispatch('updateLang');
        } else {
          const langStr = localStorage.getItem('langInfo');
          if (langStr) {
            const langMap = JSON.parse(langStr);
            for (const key in langMap) {
              i18n.mergeLocaleMessage(key, langMap[key]);
            }
            return true;
          } else {
            return dispatch('updateLang');
          }
        }
      });
    } else {
      return dispatch('updateLang');
    }
  },

  updateLang({state}) {
    let $vue = this._vm;
    return $vue.$h5Api({
      type: '2018',
      data: [{}],
    }).then(({data}) => {
      const {langMap, updateTime} = data.LANG_APP;
      localStorage.setItem('langTime', updateTime);
      localStorage.setItem('langInfo', JSON.stringify(langMap));
      for (const key in langMap) {
        i18n.mergeLocaleMessage(key, langMap[key]);
      }
    });
  },

  autoLoginByWorkWeChatCode({ commit }, code){
    let $vue = this._vm;
    return $vue.$h5Api({
      type: `2040`,
      data:[{CODE: code,SYS_TYPE:20011003 }],
      showMessage: false
    }).then(({ data }) => {
      commit('afterLogin', data);
    }).catch(e => {
      commit('saveOpenId', e.data.value);
      throw e;
    });
  },
};

export default actions;
